import apiClient from './client';

export interface LoginResponse {
  token: string;
  storeId: number | null;
  isSuperAdmin: boolean;
  isMasterAdmin: boolean;
}

export const login = async (email: string, password: string): Promise<LoginResponse> => {
  const { data } = await apiClient.post<LoginResponse>('/auth/login', { email, password });
  return data;
};
